// @flow

import axios from "axios";

const API_BASE = "/api";

export type Settings = {
    authUrl: string,
    clientId: string,
};

export default (settings?: Settings) => {
    const client = axios.create({
        baseURL: API_BASE,
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
        validateStatus: (status: number) => status >= 200 && status < 400,
    });

    if (settings) {
        client.interceptors.response.use(
            (response: any) => response,
            (error: any) => {
                // TODO (POLISH)
                // console.log(
                //     "ERROR INTERCEPTOR",
                //     error.response.data.message,
                //     error.response.statusText,
                //     error.response.status,
                // );
                // check Lucas if refreshtokens
                // if refresh => first refresh

                if (error?.response?.status === 401) {
                    return (window.location.href = `${settings.authUrl}/login?client_id=${settings.clientId}&response_type=code&scope=email+openid+profile&redirect_uri=${window.location.origin}/api/oidc-callback`);
                }

                // throw new Error(error);
                return Promise.reject(error);
            },
        );
    }

    return client;
};
